import { useEffect, useState } from "react";

export default function EnrollmentWorkflowTimeline({ studentEnrollmentId, loadHistory, isAdmin = false }) {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let active = true;
    if (!studentEnrollmentId) {
      setLoading(false);
      return undefined;
    }
    setLoading(true);
    setError("");
    loadHistory(studentEnrollmentId)
      .then((data) => active && setHistory(Array.isArray(data) ? data : []))
      .catch(() => active && setError("Unable to load workflow history."))
      .finally(() => active && setLoading(false));
    return () => { active = false; };
  }, [studentEnrollmentId, loadHistory]);

  if (loading) return <div className="text-sm text-slate-500">Loading workflow history...</div>;
  if (error) return <div className="text-sm text-rose-600">{error}</div>;
  if (!history.length) return <div className="text-sm text-slate-500">No workflow history is available yet.</div>;

  return <ol className="space-y-4 border-l-2 border-slate-200 pl-5">
    {history.map((item) => (
      <li key={item.wfsLogNo} className="relative">
        <span className={`absolute -left-[1.72rem] top-1 h-3 w-3 rounded-full ${item.isCurrent ? "bg-orange-500 ring-4 ring-orange-100" : "bg-slate-300"}`} />
        <div className="flex flex-wrap items-center gap-2">
          <span className="font-semibold text-[#0A2540]">{item.workFlowStatusName || "Workflow updated"}</span>
          {item.isCurrent && <span className="rounded-full bg-orange-100 px-2 py-0.5 text-xs font-semibold text-orange-700">Current</span>}
          <span className="text-xs text-slate-500">{item.logDt ? new Date(item.logDt).toLocaleString("en-AU") : ""}</span>
        </div>
        {isAdmin && <div className="mt-1 text-sm text-slate-600">{item.prevWorkFlowStatusName ? `${item.prevWorkFlowStatusName} → ${item.workFlowStatusName}` : "Starting status"}</div>}
        {isAdmin && item.remarks && <div className="mt-1 text-sm text-slate-600">{item.remarks}</div>}
        {isAdmin && item.changedBy && <div className="mt-1 text-xs text-slate-500">Changed by {item.changedBy}</div>}
      </li>
    ))}
  </ol>;
}
